import { listUnits, standardizeAddress } from "./api.mjs";
//#region src/helpers/addressValidation.ts
var UNIVERSAL_NIL_ADDRESS = "6aae647b-d603-5533-8464-c42c658b101a";
var ADDRESS_INVALID_RESULT = [
	"ADDRESS_NIL",
	"ADDRESS_UNKNOWN",
	"ADDRESS_MISSING_PREMISE",
	"ADDRESS_INVALID_PREMISE",
	"ADDRESS_NOT_SUPPORTED",
	"ADDRESS_NOT_REAL",
	"ADDRESS_INVALID",
	"ADDRESS_INVALID_STREET",
	"ADDRESS_INVALID_SUB_PREMISE",
	"ADDRESS_MISSING_BOX_NUMBER",
	"ADDRESS_INVALID_BOX_NUMBER",
	"ADDRESS_EXTRANEOUS_INPUT"
];
var doesAddressHaveMultipleUnits = async (addressUuid) => {
	return ((await listUnits(addressUuid))?.data?.casa?.listUnits?.addresses || []).some((address) => address.uuid !== addressUuid && !address.result?.some((casaResult) => ADDRESS_INVALID_RESULT.includes(casaResult)));
};
var validateAddress = async (address) => {
	let moreResult = [];
	let casaAddress = address;
	if (address.source === "google") {
		const standardizeAddressResponse = await standardizeAddress(address);
		if (!standardizeAddressResponse || !standardizeAddressResponse.data || standardizeAddressResponse.errors || standardizeAddressResponse.data?.casa.findByFields?.address?.uuid === "6aae647b-d603-5533-8464-c42c658b101a") {
			moreResult = ["ADDRESS_UNKNOWN"];
			return {
				address,
				results: moreResult,
				needsManualEntry: true,
				needsUnitSelection: false
			};
		}
		const addressResult = standardizeAddressResponse.data?.casa.findByFields?.address;
		casaAddress = {
			id: addressResult.uuid,
			street1: addressResult.street,
			city: addressResult.city,
			state: addressResult.state,
			postal_code: addressResult.postalCode,
			unit: addressResult.unitNumber,
			result: addressResult.result,
			latitude: address.latitude,
			longitude: address.longitude,
			source: "casa"
		};
	}
	if (!casaAddress?.result?.includes("ADDRESS_MISSING_SUB_PREMISE") && casaAddress?.unit === "") {
		if (casaAddress.id && await doesAddressHaveMultipleUnits(casaAddress.id)) moreResult = ["ADDRESS_MISSING_SUB_PREMISE"];
	}
	const combinedResults = [...casaAddress?.result || [], ...moreResult];
	const needsManualEntry = ADDRESS_INVALID_RESULT.some((error) => combinedResults.includes(error));
	const needsUnitSelection = combinedResults.includes("ADDRESS_MISSING_SUB_PREMISE");
	return {
		address: casaAddress,
		results: combinedResults,
		needsManualEntry,
		needsUnitSelection
	};
};
//#endregion
export { ADDRESS_INVALID_RESULT, UNIVERSAL_NIL_ADDRESS, validateAddress };

//# sourceMappingURL=addressValidation.mjs.map